import { Alert, DialogTitle, Stack, Typography } from "@mui/material";
import { CommonDialog } from "@/components/common/CommonDialog";
import { FormButtonGroup } from "@/components/form";

interface HealthPlanModalsProps {
  isActivateModalOpen: boolean;
  isCancelModalOpen: boolean;
  isLoading: boolean;
  onCloseActivateModal: () => void;
  onCloseCancelModal: () => void;
  onConfirmActivate: () => void;
  onConfirmCancel: () => void;
  agentName: string;
}

export function HealthPlanModals({
  isActivateModalOpen,
  isCancelModalOpen,
  isLoading,
  onCloseActivateModal,
  onCloseCancelModal,
  onConfirmActivate,
  onConfirmCancel,
  agentName,
}: HealthPlanModalsProps) {
  return (
    <>
      {/* Modal de Ativação */}
      <CommonDialog
        isOpen={isActivateModalOpen}
        handleClose={onCloseActivateModal}
        maxWidth="sm"
      >
        <DialogTitle align="center">
          Confirmar Ativação da extensão {agentName}
        </DialogTitle>

        <Stack spacing={3}>
          <Typography
            variant="subtitle2"
            fontWeight="500"
            align="center"
            mb={2}
          >
            Ao confirmar, você ativará a extensão {agentName} e terá acesso
            imediato aos benefícios exclusivos. Aproveite essa nova experiência!
          </Typography>

          <FormButtonGroup
            onGoBackButtonClick={onCloseActivateModal}
            onNextButtonClick={onConfirmActivate}
            loading={isLoading}
            goBackButtonText="Fechar"
            nextButtonText={isLoading ? "Ativando..." : "Confirmar"}
            disabled={isLoading}
            maxWidth
          />
        </Stack>
      </CommonDialog>

      {/* Modal de Cancelamento */}
      <CommonDialog
        isOpen={isCancelModalOpen}
        handleClose={onCloseCancelModal}
        maxWidth="sm"
      >
        <DialogTitle align="center">
          Tem certeza que deseja desativar a extensão <b>{agentName}</b>?
        </DialogTitle>

        <Stack spacing={3}>
          {/* 
            Mensagem aprimorada com foco em clareza, empatia e destaque visual.
            - Usa o componente Alert do MUI para melhor acessibilidade e padrão visual.
            - Ícone de warning destacado.
            - Texto objetivo, tom respeitoso e alerta.
            - Layout centralizado e fácil de ler.
          */}
          <Stack mb={2}>
            <Alert
              severity="warning"
              variant="outlined"
              sx={{
                alignItems: "center",
                fontSize: "1rem",
                backgroundColor: "#FFF8E1",
                borderColor: "#FF9800",
                color: "#7A4F01",
                justifyContent: "center",
                textAlign: "center",
              }}
              icon={false}
            >
              <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
                <span style={{ color: "#FF9800", fontSize: 24, marginRight: 8 }}>⚠️</span>
                <Typography variant="subtitle2" fontWeight="500" component="span">
                    Ao confirmar, todos os recursos e benefícios dessa extensão serão imediatamente removidos para sua clínica.<br />
                </Typography>
              </Stack>
            </Alert>
          </Stack>

          <FormButtonGroup
            onGoBackButtonClick={onCloseCancelModal}
            onNextButtonClick={onConfirmCancel}
            loading={isLoading}
            goBackButtonText="Fechar"
            nextButtonText={
              isLoading ? "Cancelando..." : "Confirmar"
            }
            disabled={isLoading}
            maxWidth
          />
        </Stack>
      </CommonDialog>
    </>
  );
}
